import appRequest from "../utils/request";

export function validateDiscountCode(code) {
    try {

        const uri = '/v1/discount-codes/validate'

        return appRequest({
            uri,
            method: 'POST',
            body: { code }
        }).then((result) => {
            return Promise.resolve(result.data)
        }).catch((error) => {
            return Promise.reject(error)
        })

    } catch (e) {
        return Promise.reject(e)
    }
}